function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuantityInput = /*#__PURE__*/function (_HTMLElement) {
  function QuantityInput() {
    var _this;
    _classCallCheck(this, QuantityInput);
    _this = _callSuper(this, QuantityInput);
    _this.init();
    return _this;
  }
  _inherits(QuantityInput, _HTMLElement);
  return _createClass(QuantityInput, [{
    key: "init",
    value: function init() {
      this.initClickEvents();
    }
  }, {
    key: "initClickEvents",
    value: function initClickEvents() {
      this.initMinusClick();
      this.initPlusClick();
    }
  }, {
    key: "initMinusClick",
    value: function initMinusClick() {
      var _this2 = this;
      var minusBtn = this.querySelector("[data-operator='minus']");
      minusBtn === null || minusBtn === void 0 || minusBtn.addEventListener('click', function () {
        _this2.quantityMinus();
      });
    }
  }, {
    key: "initPlusClick",
    value: function initPlusClick() {
      var _this3 = this;
      var plusBtn = this.querySelector("[data-operator='plus']");
      plusBtn === null || plusBtn === void 0 || plusBtn.addEventListener('click', function () {
        _this3.quantityPlus();
      });
    }
  }, {
    key: "quantityMinus",
    value: function quantityMinus() {
      var quantityInput = this.querySelector(".input") || document.createElement("input");
      var min = Number(quantityInput === null || quantityInput === void 0 ? void 0 : quantityInput.getAttribute('min')) || 1;
      var qty = Number(quantityInput.value);
      var step = quantityInput.step ? Number(quantityInput.step) : 1;
      if (qty <= min) {
        qty = min;
      } else {
        qty -= step;
      }
      quantityInput.value = qty.toString();
      this.updatePrices(qty);
    }
  }, {
    key: "quantityPlus",
    value: function quantityPlus() {
      var quantityInput = this.querySelector('.input') || document.createElement('input');
      var max = Number(quantityInput === null || quantityInput === void 0 ? void 0 : quantityInput.getAttribute('max'));
      var qty = Number(quantityInput.value);
      var step = quantityInput.step ? Number(quantityInput.step) : 1;
      if (!max || max <= 0) {
        qty += step;
      } else if (qty < max) {
        qty += step;
      }
      quantityInput.value = qty.toString();
      this.updatePrices(qty);
    }
  }, {
    key: "updatePrices",
    value: function updatePrices(qty) {
      var quantity = Number(qty);
      this.updateOneTimePrice(quantity);
      this.updateCurrentSubscriptionPrice(quantity);
      this.updatePriceOnSelectOptions(quantity);
      this.updateProductPrice(quantity);
    }
  }, {
    key: "updateOneTimePrice",
    value: function updateOneTimePrice(qty) {
      var oneTimePriceEl = document.getElementById('oneTimePrice');
      if (!oneTimePriceEl) return;
      var dataPrice = oneTimePriceEl.getAttribute('data-price');
      var dataArtificialPrice = oneTimePriceEl.getAttribute('data-artificial-price');
      if (!dataPrice) return;
      var oneTimePrice = Number(dataPrice.replace('$', ''));
      var oneTimeArtificialPrice = dataArtificialPrice ? Number(dataArtificialPrice.replace('$', '')) : null;
      var newOneTimePrice = oneTimePrice * qty;
      var newArtificialPrice = oneTimeArtificialPrice ? oneTimeArtificialPrice * qty : null;
      oneTimePriceEl.innerHTML = newArtificialPrice ? "$".concat(newArtificialPrice.toFixed(2), " <del class=\"discounted-price__artificial\">$").concat(newOneTimePrice.toFixed(2), "</del>") : "$".concat(newOneTimePrice.toFixed(2));
    }
  }, {
    key: "updateCurrentSubscriptionPrice",
    value: function updateCurrentSubscriptionPrice(qty) {
      var currentSubscriptionPriceEl = document.getElementById('currentSubscriptionPrice');
      if (!currentSubscriptionPriceEl) return;
      var dataPrice = currentSubscriptionPriceEl.getAttribute('data-price');
      var dataArtificialPrice = currentSubscriptionPriceEl.getAttribute('data-artificial-subscription-price');
      if (!dataPrice) return;
      var currentSubscriptionPrice = Number(dataPrice.replace('$', ''));
      var currentArtificialSubscriptionPrice = dataArtificialPrice ? Number(dataArtificialPrice.replace('$', '')) : null;
      var newCurrentSubscriptionPrice = currentSubscriptionPrice * qty;
      var newArtificialSubscriptionPrice = currentArtificialSubscriptionPrice ? currentArtificialSubscriptionPrice * qty : null;
      currentSubscriptionPriceEl.innerHTML = newArtificialSubscriptionPrice ? "$".concat(newArtificialSubscriptionPrice.toFixed(2), " <del class=\"discounted-price__artificial\">$").concat(newCurrentSubscriptionPrice.toFixed(2), "</del>") : "$".concat(newCurrentSubscriptionPrice.toFixed(2));
    }
  }, {
    key: "updatePriceOnSelectOptions",
    value: function updatePriceOnSelectOptions(qty) {
      var selectElement = document.querySelector('#subscriptionPlan');
      if (!selectElement) return;
      selectElement.querySelectorAll('option').forEach(function (option) {
        var dataPrice = option.getAttribute('data-price-base');
        if (!dataPrice) return;
        var price = Number(dataPrice.replace('$', ''));
        var newPrice = price * qty;
        option.setAttribute('data-price', "$".concat(newPrice.toFixed(2)));
      });
    }
  }, {
    key: "updateProductPrice",
    value: function updateProductPrice(qty) {
      var productPriceEl = document.getElementById('productPrice');
      if (!productPriceEl) return;
      var dataPrice = productPriceEl.getAttribute('data-price');
      var dataArtificialPrice = productPriceEl.getAttribute('data-artificial-price');
      if (!dataPrice) return;
      var productPrice = Number(dataPrice.replace('$', ''));
      var artificialPrice = dataArtificialPrice ? Number(dataArtificialPrice.replace('$', '')) : null;
      var newProductPrice = productPrice * qty;
      var newArtificialPrice = artificialPrice ? artificialPrice * qty : null;
      productPriceEl.innerHTML = newArtificialPrice ? "<span class=\"artificial-price\">$".concat(newArtificialPrice.toFixed(2), "</span> <del>$").concat(newProductPrice.toFixed(2), "</del>") : "$".concat(newProductPrice.toFixed(2));
      var productComparePriceEl = document.getElementById('productComparePrice');
      if (!productComparePriceEl) return;
      var dataComparePrice = productComparePriceEl.getAttribute('data-price');
      if (!dataComparePrice) return;
      var productComparePrice = Number(dataComparePrice.replace('$', ''));
      var newProductComparePrice = productComparePrice * qty;
      productComparePriceEl.innerText = "$".concat(newProductComparePrice.toFixed(2));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default QuantityInput;